import Handlebars from "handlebars/dist/handlebars";

class RoadWorksResults {

    constructor(element) {

        this.wrapper = element;
        
        this.originalData = JSON.parse(this.wrapper.dataset.results);
        
        this.filteredData = JSON.parse(JSON.stringify(this.originalData));
        
        this.resultsListingTemplate = Handlebars.compile(document.querySelector("#road-works__results-listing-template").innerHTML);
        
        this.activityFilter = document.getElementById("road-works__results-activity-filter");
        
        this.initialise();

    }
    
    filterResults() {
        
        // Reset filtered data to original results
        this.filteredData = JSON.parse(JSON.stringify(this.originalData));
        
        if (this.activityFilter) {
        
            // console.log(this.filteredData);
            
            const selectedIndex = this.activityFilter.selectedIndex;
            
            if (selectedIndex) {
                
                const selectedValue = this.activityFilter.value.toLowerCase(); 
                
                this.filteredData.map(monthSchedule => {
                   
                    monthSchedule.activities = monthSchedule.activities.filter( (activity) => {
                    
                        if (activity.name.toLowerCase() ===  selectedValue) {
                            return true;
                        }
                    
                    });
                    
                });
                
                
            }
           
        }
        
        this.renderResults();
        
        
    }
    
    setupActivityFilter() {
        
        if (this.activityFilter) {
            
            this.activityFilter.addEventListener("change", this.filterResults.bind(this));
            
            this.activityFilter.disabled = false;
            
        }
        
    }
       
    renderResults() {
        
        this.wrapper.innerHTML = this.resultsListingTemplate(this.filteredData);
        
    }
    
    initialise() {

        this.renderResults();
        
        this.setupActivityFilter();

    }

}

export default RoadWorksResults;






